// Chart default configurations for Revenue/Profit trend
export const DefaultChat = {
  icon: "discount-chart",
  value: "line",
  tip: "Line chart",
  format: true,
};

export const showRevenueTrendList = ['line', 'bar', 'table'];
